<form
  #form="ngForm"
  novalidate
>
  <div class="flex w-full flex-col gap-y-2 whitespace-nowrap">
    <nsp-calendar-input
      name="startedBunkering"
      id="startedBunkering"
      label="Started Bunkering at"
      [labelWidthPercentage]="33"
      [required]="this.bunkerStore.vm().hasFuelTypeSelected()"
      [readonly]="
        isFieldReadOnly('startedBunkering') ||
        !this.bunkerStore.vm().hasFuelTypeSelected()
      "
      [value]="this.bunkerStore.fuelOilBunkers().startedBunkering.value"
      [ngModel]="this.bunkerStore.fuelOilBunkers().startedBunkering.value"
    />
    <nsp-calendar-input
      name="finishedBunkering"
      id="finishedBunkering"
      label="Finished Bunkering at"
      [labelWidthPercentage]="33"
      [required]="this.bunkerStore.vm().hasFuelTypeSelected()"
      [readonly]="
        isFieldReadOnly('finishedBunkering') ||
        !this.bunkerStore.vm().hasFuelTypeSelected()
      "
      [min]="this.bunkerStore.fuelOilBunkers().startedBunkering.value"
      [value]="this.bunkerStore.fuelOilBunkers().finishedBunkering.value"
      [ngModel]="this.bunkerStore.fuelOilBunkers().finishedBunkering.value"
    />
  </div>
</form>
